module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "el-form",
    class: [
      _vm.labelPosition ? 'el-form--label-' + _vm.labelPosition : '',
      {
        'el-form--inline': _vm.inline
      }
    ]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43f8283e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/element-ui/packages/form/src/form.vue
// module id = 556
// module chunks = 4 5 6